/**
 * ハッシュリンククリック時smooth、 headerガター調整
 */
export default function initSmoothScroll() {
  new ScrollHint(".wp-block-flexible-table-block-table");
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  anchorLinks.forEach(_addClickEventListener);

  // アンカー付きでページ遷移した場合
  const urlHash = location.hash;
  if (urlHash) {
    const targetElm = document.querySelector(urlHash);
    window.addEventListener("load", () => {
      // 1フレーム待機 + さらにわずかに待機（Safari対策）
      requestAnimationFrame(() => {
        // ▼▼▼ 変更点1: setTimeoutで遅延実行 ▼▼▼
        setTimeout(() => {
          // 第2引数に false を渡し、読み込み時は瞬時に移動させる
          _scrollToTarget(targetElm, false);
        }, 100); // 100ミリ秒待機（状況に応じて調整）
        // ▲▲▲ 変更ここまで ▲▲▲
      });
    });
  }

  // MutationObserverを使って動的に追加されたリンクを監視する
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches('a[href*="#"]')
        ) {
          _addClickEventListener(node);
        }

        // 子孫要素もチェック
        node.querySelectorAll?.('a[href*="#"]').forEach(_addClickEventListener);
      });
    });
  });

  // body配下の監視を開始
  observer.observe(document.body, { childList: true, subtree: true });

  // aタグにクリックイベントを追加する関数
  function _addClickEventListener(link) {
    link.addEventListener("click", (e) => {
      const targetElm = document.querySelector(link.hash);

      if (targetElm) {
        e.preventDefault();

        // === ▼ スマホ時：ドロワー内リンクなら閉じる ▼ ===
        const drawer = document.getElementById("js-site-drawer");
        if (drawer && drawer.contains(link) && window.innerWidth <= 768) {
          drawer.removeAttribute("open");
        }
        // === ▲ ここまで追加 ▲ ===

        _scrollToTarget(targetElm);
      }
    });
  }

  // 引数のターゲットをもとに画面スクロールする関数
  function _scrollToTarget(targetElm, smooth = true) {
    if (targetElm) {
      const targetRect = targetElm.getBoundingClientRect().top;
      const header = document.querySelector(".js-header-fixed");
      const fixGutter = header ? header.clientHeight : 0;

      const targetPos = targetRect + window.scrollY - fixGutter - 30;

      window.scrollTo({
        top: targetPos,
        behavior: smooth ? "smooth" : "auto",
      });
    }
  }
}
